import Image from "next/image";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import IFSform from "./ifs-interview-form";
import styles from "../upsc-interview/upsc-interview.module.css";
import IFSinterview from "../../assets/images/upsc/IFS interview.png";

const ifsInterview2023 = () =>{

    const prelimlist =[
        {list:"79 out of 108 selections in IFS 2021 are from Shankar IAS Academy."},
        {list:"73% of All India results are from Shankar IAS Academy."},
        {list:"7 Rank holders among top 10 ranks in IFS 2021."},
        {list:"9 Rank holders are women among the 52 selections from Shankar IAS Academy."},
      ]

    return(
        <>
        <Navbar title="IFS-Interview-2023" />

        <div className="container">

        <div className="row">
        <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>IFS Interview 2023</h1>
        </div>
        </div>

        <div className="row">
        <div className="col pt-3 mb-3">
                    <Image
                    src={IFSinterview}
                    className="img-fluid w-100"
                    alt="IFS interview Banner"
                    title="IFS Interview 2023"            
                    />
        </div>
        </div>

        </div>
        
        <IFSform />

        <div className="container pt-3 pt-md-4">

            <div className="row">
                <div className="col">
                    <h2 className={`${styles.contactheader}`}>SHANKAR IAS ACADEMY EDGE!</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-md-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Individual personalised<br />one-on-one session.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Mock interviews by<br />eminent panelists,<br />serving bureaucrats.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>Group based<br />DAF profiling.</p>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 text-center pt-3 pt-lg-3 pt-xl-0">
                    <div className="p-4 h-100 py-5" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                        <p className={`${styles.acheivername1} mb-0`}>and much more...</p>
                    </div>
                </div>
            </div>

            <div className="row pt-4 pt-md-5">
                <div className="col">
                    <p className={`${styles.sectionsubtitle}`}>OUR ACHIEVEMENTS - 2021 INTERVIEW</p>

                        <ul className={`${styles.ulclass} ps-1 pt-2`}>
                            {prelimlist.map((item,index)=>(
                                  <li
                                    className={`${styles.ulliclass} ${styles.acheiverrank}`}
                                    id={styles.acheiverrankspecial} key={index}
                                  >
                                    <div className="d-inline">
                                      <p className={`${styles.ullispan} d-inline`}>
                                        {item.list}
                                      </p>
                                    </div>
                                  </li>
                              ))}
                        </ul>

                    <h2 className={`${styles.contactheader} mb-0`}>SIA Produces toppers from Tamilnadu for IFS for the 8th consecutive year.</h2>
                </div>
            </div>

        </div>

        <Footer />
        </>
    )
}
export default ifsInterview2023